module.exports = __webpack_public_path__ + "static/media/reEvaluateNormal.ea7a2665.svg";